import { css, Theme } from '@emotion/react'
import { alpha } from '@mui/material'

export const tableWrapper = (theme: Theme) => css`
  max-width: 100%;
  overflow: hidden;
  margin-bottom: ${theme.spacing(4)};
  padding: ${theme.spacing(1)};
  border: 1px solid ${theme.colors.backgroundOne};
  border-radius: 16px;
  box-shadow: 0px 4px 5px -2px ${alpha('#8A94A6', 0.13)};
`

export const table = (theme: Theme) => css`
  row-gap: 5px;

  .table-header {
    min-height: 46px;
    padding: ${theme.spacing(0.75, 1.75)};

    .table-cell {
      font-weight: 600;
    }
  }

  .table-row {
    min-height: 46px;
    border: none;
    box-shadow: none;
    padding: ${theme.spacing(1.75)};

    &:nth-of-type(2n + 1) {
      background: ${theme.colors.backgroundFive};
    }
  }

  .table-cell {
    font-size: 14px;
    line-height: 18px;
    color: ${theme.colors.typographyTwo};
  }
`

export const tableFooter = (theme: Theme) => css`
  display: flex;
  justify-content: flex-end;
  column-gap: ${theme.spacing(1.5)};

  margin-top: ${theme.spacing(2.25)};
  padding: ${theme.spacing(0, 1.5)};
`
